import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule, BrowserTransferStateModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CookieService} from "ngx-cookie-service";
import {NgxSpinnerModule} from "ngx-spinner";
import {HttpClientModule} from "@angular/common/http";
import {DialogModule} from "./components/generics/dialog/dialog.module";
import {PuntoVenditaFactory} from "./models/PuntoVendita";
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS} from "@angular/material-moment-adapter";
import {GenericsModule} from './components/generics/generics.module';
import {MatDialogModule} from "@angular/material/dialog";
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatIconModule} from "@angular/material/icon";
import {HasPermPipe} from "./pipes/has-perm.pipe";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {MatButtonModule} from "@angular/material/button";
import {DxDataGridModule} from "devextreme-angular";


@NgModule({
   declarations: [
      AppComponent,
   ],
   imports: [
      BrowserModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      BrowserTransferStateModule,
      HttpClientModule,
      NgxSpinnerModule,
      DialogModule,
      GenericsModule,
      MatDialogModule,
      MatAutocompleteModule,
      MatSnackBarModule,
      MatIconModule,
      NgxMatSelectSearchModule,
      MatButtonModule,
      DxDataGridModule,
   ],
   providers: [
      {provide: MAT_DATE_LOCALE, useValue: 'it-IT'},
      {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
      {provide: LOCALE_ID, useValue: 'it'},
      CookieService,
      PuntoVenditaFactory,
      {
         provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
         useValue: {
            useUtc: false
         }
      },
      HasPermPipe
   ],
   exports: [

   ],
   bootstrap: [AppComponent]
})
export class AppModule { }
